import { Avatar, type AvatarProps } from '@/components/ui/Avatar';
import { useUserPhoto } from '@/hooks/useUserPhoto';

interface UserAvatarProps extends Omit<AvatarProps, 'src'> {
  photoUrl?: string | null;
}

export function UserAvatar({
  photoUrl,
  name,
  size = 'md',
  className,
  status,
}: UserAvatarProps) {
  const src = useUserPhoto(photoUrl);

  return (
    <Avatar
      src={src}
      name={name}
      size={size}
      className={className}
      status={status}
    />
  );
}
